import clsx from "clsx";
import { PropsWithChildren } from "react";
import { PolymorphicComponent } from "../PolymorphicComponent";
import { ScrollWindowAxis, ScrollWindowAxisOptions } from "./types";

type ScrollWindowProps = {
  className?: string;
  axis?: ScrollWindowAxisOptions;
};

export function ScrollWindow({
  axis = ScrollWindowAxis.y,
  className,
  children,
  ...props
}: PropsWithChildren<ScrollWindowProps>) {
  return (
    <PolymorphicComponent
      className={clsx("scrollbar-semi-transparent", className, {
        "overflow-y-scroll": axis === ScrollWindowAxis.y,
        "overflow-x-scroll": axis === ScrollWindowAxis.x,
        "overflow-scroll": axis === ScrollWindowAxis.xy,
      })}
    >
      {children}
    </PolymorphicComponent>
  );
}
